import { type FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ScCopyCode } from './styled';

interface CopyCodeProps {
  code: string;
  copyActive?: boolean;
  hoverColor?: string;
  noMarginBottom?: boolean;
  copyCodeTitle?: string;
}

export const CopyCode: FC<CopyCodeProps> = ({
  code,
  hoverColor,
  noMarginBottom,
  copyCodeTitle,
}) => {
  const { t } = useTranslation('common');
  const [copyActive, setCopyActive] = useState(false);

  const handleCopyCode = useCallback(() => {
    navigator.clipboard.writeText(code);
    setCopyActive(true);
  }, [code, setCopyActive]);

  const handleAnimationEnd = () => {
    setCopyActive(false);
  };

  return (
    <>
      {code && (
        <ScCopyCode
          copyActive={copyActive}
          hoverColor={hoverColor}
          noMarginBottom={noMarginBottom}
        >
          <p>{copyCodeTitle || t('copyCode.copyText')}</p>
          <span
            data-access={t('copyCode.access')}
            onAnimationEnd={handleAnimationEnd}
            onClick={handleCopyCode}
          >
            <span className="notranslate" translate="no">
              {code}
            </span>
          </span>
        </ScCopyCode>
      )}
    </>
  );
};
